import React, { useEffect, useState } from 'react';
import vocaData from '../data/vocaAnalytics.json';
import VOCAVisualization from './VOCAVisualization';


const VocaMain = () => {

    return (
        <div>
            <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white  mb-4">Voice of Customer Analytics Visualizations</h3>
                <p className="text-gray-600 dark:text-gray-100  mb-6">Interactive charts and data tables showing customer feedback analysis across sentiment, topics, and actionable insights.</p>

                {/* VOCA Advanced Visualizations */}
                <VOCAVisualization
                    analyticsResults={vocaData.analytics}
                    loading={false}
                />

                {/* VOCA Results Display */}
                {vocaData?.analysis_summary && (
                    <div className="space-y-6">
                        {/* Summary Cards */}
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                            <div className="bg-white  p-4 rounded-xl shadow-sm border border-gray-100 ">
                                <div className="flex items-center">
                                    <div className="p-2 bg-blue-100  rounded-lg mr-3">
                                        <svg className="w-6 h-6 text-blue-600 " fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="text-2xl font-bold text-gray-900 ">{vocaData.analysis_summary.total_comments}</p>
                                        <p className="text-sm text-gray-500 ">Total Comments</p>
                                    </div>
                                </div>
                            </div>

                            <div className="bg-white  p-4 rounded-xl shadow-sm border border-gray-100 ">
                                <div className="flex items-center">
                                    <div className="p-2 bg-green-100  rounded-lg mr-3">
                                        <svg className="w-6 h-6 text-green-600 " fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1m4 0h1m-6 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="text-2xl font-bold text-green-600 ">{vocaData.analysis_summary.sentiment_distribution.positive}</p>
                                        <p className="text-sm text-gray-500 ">Positive</p>
                                    </div>
                                </div>
                            </div>

                            <div className="bg-white  p-4 rounded-xl shadow-sm border border-gray-100 ">
                                <div className="flex items-center">
                                    <div className="p-2 bg-red-100  rounded-lg mr-3">
                                        <svg className="w-6 h-6 text-red-600 " fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 12h6m-6 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="text-2xl font-bold text-red-600 ">{vocaData.analysis_summary.sentiment_distribution.negative}</p>
                                        <p className="text-sm text-gray-500 ">Negative</p>
                                    </div>
                                </div>
                            </div>

                            <div className="bg-white  p-4 rounded-xl shadow-sm border border-gray-100 ">
                                <div className="flex items-center">
                                    <div className="p-2 bg-yellow-100  rounded-lg mr-3">
                                        <svg className="w-6 h-6 text-yellow-600 " fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="text-2xl font-bold text-yellow-600 ">{vocaData.analysis_summary.urgency_distribution.high || 0}</p>
                                        <p className="text-sm text-gray-500 ">High Urgency</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Sentiment Distribution Chart */}
                        <div className="bg-white  p-6 rounded-xl shadow-sm border border-gray-100 ">
                            <h4 className="text-lg font-semibold text-gray-800  mb-4">Sentiment Distribution</h4>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <div className="space-y-3">
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm text-gray-600 ">Positive</span>
                                            <span className="text-sm font-medium text-green-600">{vocaData.analysis_summary.sentiment_distribution.positive}</span>
                                        </div>
                                        <div className="w-full bg-gray-200  rounded-full h-2">
                                            <div
                                                className="bg-green-500 h-2 rounded-full"
                                                style={{ width: `${(vocaData.analysis_summary.sentiment_distribution.positive / vocaData.analysis_summary.total_comments) * 100}%` }}
                                            ></div>
                                        </div>
                                    </div>
                                    <div className="space-y-3 mt-4">
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm text-gray-600 ">Negative</span>
                                            <span className="text-sm font-medium text-red-600">{vocaData.analysis_summary.sentiment_distribution.negative}</span>
                                        </div>
                                        <div className="w-full bg-gray-200  rounded-full h-2">
                                            <div
                                                className="bg-red-500 h-2 rounded-full"
                                                style={{ width: `${(vocaData.analysis_summary.sentiment_distribution.negative / vocaData.analysis_summary.total_comments) * 100}%` }}
                                            ></div>
                                        </div>
                                    </div>
                                    <div className="space-y-3 mt-4">
                                        <div className="flex justify-between items-center">
                                            <span className="text-sm text-gray-600 ">Neutral</span>
                                            <span className="text-sm font-medium text-gray-600">{vocaData.analysis_summary.sentiment_distribution.neutral}</span>
                                        </div>
                                        <div className="w-full bg-gray-200  rounded-full h-2">
                                            <div
                                                className="bg-gray-500 h-2 rounded-full"
                                                style={{ width: `${(vocaData.analysis_summary.sentiment_distribution.neutral / vocaData.analysis_summary.total_comments) * 100}%` }}
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <h5 className="text-md font-semibold text-gray-700  mb-3">Intent Distribution</h5>
                                    <div className="space-y-2">
                                        {Object.entries(vocaData.analysis_summary.intent_distribution).map(([intent, count]) => (
                                            <div key={intent} className="flex justify-between items-center">
                                                <span className="text-sm text-gray-600  capitalize">{intent}</span>
                                                <span className="text-sm font-medium text-gray-800 ">{count}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Sample Individual Results */}
                        {vocaData.individual_results && vocaData.individual_results.length > 0 && (
                            <div className="bg-white  p-6 rounded-xl shadow-sm border border-gray-100 ">
                                <h4 className="text-lg font-semibold text-gray-800  mb-4">Sample Analysis Results</h4>
                                <div className="space-y-4 max-h-96 overflow-y-auto">
                                    {vocaData.individual_results.slice(0, 5).map((item, index) => (
                                        <div key={index} className="border border-gray-200  rounded-lg p-4">
                                            <div className="flex justify-between items-start mb-2">
                                                <span className={`px-2 py-1 rounded-full text-xs font-medium ${item.sentiment.overall === 'positive' ? 'bg-green-100 text-green-800 ' :
                                                    item.sentiment.overall === 'negative' ? 'bg-red-100 text-red-800  ' :
                                                        'bg-gray-100 text-gray-800  '
                                                    }`}>
                                                    {item.sentiment.overall}
                                                </span>
                                                <span className="text-xs text-gray-500  capitalize">{item.intent.primary_intent}</span>
                                            </div>
                                            <p className="text-sm text-gray-700  mb-2">{item.summary}</p>
                                            <p className="text-xs text-gray-500  italic">
                                                "{item.analysis_metadata.original_comment.substring(0, 150)}..."
                                            </p>
                                            {item.key_insights.pain_points.length > 0 && (
                                                <div className="mt-2">
                                                    <span className="text-xs font-medium text-red-600 ">Pain Points: </span>
                                                    <span className="text-xs text-gray-600 ">
                                                        {item.key_insights.pain_points.join(', ')}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default VocaMain;